'use client'

import React, { useCallback, useEffect, useState } from 'react'
import NextLink from 'next/link'
import NextImage from 'next/image'

import Button from '@/components/Button'
import {
	LeftArrowIcon,
	LinkIcon,
	MailIcon,
	RightArrowIcon,
	TelegramIcon,
	UpRightArrowIcon,
	VkIcon
} from '@/components/Icon'
import Typography from '@/components/Typography'

import styles from '../../styles.module.css'
import IconButton from '@/components/IconButton'
import ShareSection from '../ShareSection'
import Link from '@/components/Link'
import ArticleImages from '../ArticleImages'

const similarCases: any[] = [
	// {
	//   img: "/passport.jpeg",
	//   href: "#",
	//   badge: "Образование",
	//   title: "Внедрение искусственного интеллекта (AI)",
	//   description:
	//     "Сервис для создания сопроводительного письма в иммиграционную службу",
	// },
	// {
	//   img: "/vehicle.png",
	//   href: "#",
	//   badge: "Производство",
	//   title: "Цифровизация завода",
	//   description:
	//     "Крупнейший производитель вездеходов в Восточной Сибири и на Дальнем Востоке",
	// },
]

export default function Article2() {
	return (
		<>
			<article className={styles.article}>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Введение
					</Typography>
					<Typography variant='p1'>
						Аудит дизайна аккаунта в социальных сетях проводится с целью оценки того, насколько хорошо дизайн
						аккаунта соответствует бренду компании, привлекательности и удобству восприятия целевой аудиторией.
						Дизайн аккаунта является ключевым элементом формирования первого впечатления о компании и может влиять
						на количество подписчиков, уровень вовлеченности, лояльность и общую эффективность присутствия в
						социальных сетях.
					</Typography>
					<Typography variant='p1'>
						Аудит дизайна соцсетей помогает выявить возможности для оптимизации конверсии и повышения
						эффективности постов и рекламных кампаний.
					</Typography>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Сокращение негативного пространства
					</Typography>
					<Typography variant='p1'>
						Для привлечения внимания целевой аудитории рекомендуется сокращение пустого пространства, а также
						добавление дополнительных элементов в фирменном стиле.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/2-1.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/2-2.png').default,
								placeholder: 'blur'
							}
						]}
						row
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Типографика
					</Typography>
					<Typography variant='p1'>
						Правильный выбор типографики может усилить визуальное воздействие вашего контента и улучшить его
						читабельность.
					</Typography>
					<Typography variant='h3' className={styles.article__headline}>
						Рекомендации по улучшению типографики:
					</Typography>
					<Typography variant='p1'>
						Соблюдение пропорций: пропорциональное соотношение шрифта и пространства между строками, чтобы текст
						был легко читаем и привлекателен для глаз.
					</Typography>
					<Typography variant='p1'>
						Цвет текста должен быть контрастным фону, а также соответствовать брендингу. Также рекомендуется
						выделение дополнительным контрастным цветом наиболее значимые моменты, шильды.
					</Typography>
					<Typography variant='p1'>
						Деление текста на блоки и абзацы увеличивает читабельность и удобство восприятия.
					</Typography>
					<Typography variant='p1'>
						Жирность текста и верхний регистр. Рекомендуется редкое использование данных типов форматирования.
					</Typography>

					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/2-3.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/2-4.png').default,
								placeholder: 'blur'
							}
						]}
						row
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Оформление галереи
					</Typography>
					<Typography variant='p1'>
						Добавление оформления для постов с фотографиями выполненной работы. Для того, чтобы забрендировать
						контент рекомендуется добавление водяных знаков и оформления в фирменном стиле. Также для лучшего
						понимания контекста следует добавить описание для обложки и слайдов.
					</Typography>

					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/2-5.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/2-6.png').default,
								placeholder: 'blur'
							}
						]}
						row
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Рекламные креативы
					</Typography>
					<Typography variant='p1'>
						Рекомендуется уменьшение количества текста и дополнительных элементов для того, чтобы пользователи
						могли моментально выделить УТП. Для добавления акцентов можно использовать контрастные блоки и плашки
						в цветах фирменного стиля. В случаях, когда добавляется текст с описаниями товара или акции,
						необходимо уменьшать размер текста.
					</Typography>

					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/2-7.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/2-8.png').default,
								placeholder: 'blur'
							}
						]}
						row
					/>
				</section>

				<section className={`${styles.article__section}`}>
					<div>
						<Typography variant='h2' className={styles.article__section__text__image__headline}>
							Добавление людей
						</Typography>
						<Typography variant='p1' className={styles.article__section__text__image__description}>
							Добавление людей помогает разнообразить сетку постов, а также придаёт бренду более дружелюбный
							облик, а отношения между клиентом и брендом выстраиваются доверительные. Можно оформлять такие
							посты в цветовой палитре бренда и с использованием черно-белых фотографий. Можно добавить отдельную
							рубрику с персонажем в виде сторителла.
						</Typography>
						<ArticleImages
							images={[
								{
									src: require('../../../../../../public/images/portfolio/2-9.png').default,
									placeholder: 'blur'
								}
							]}
							scaleDown
						/>
					</div>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Оформление аккаунта
					</Typography>
					<Typography variant='p1'>
						Рекомендуется оформление профиля ВК в фирменном стиле: добавление товаров и меню. Использование этих
						разделов помогает пользователю быстро ориентироваться в аккаунте. Также использование данных блоков
						помогут рассказать о последних предложениях, акциях и актуальных продуктах.
					</Typography>
				</section>

				<section className={`${styles.article__section} ${styles.article__section__text__image}`}>
					<div className={styles.article__image__wrapper}>
						<ArticleImages
							images={[
								{
									src: require('../../../../../../public/images/portfolio/2-10.png').default,
									placeholder: 'blur'
								}
							]}
						/>
					</div>
					<div>
						<Typography variant='h4' className={styles.article__section__text__image__headline}>
							Товарные посты
						</Typography>
						<Typography variant='p1' className={styles.article__section__text__image__description}>
							Данный тип постов повышает уровень заинтересованности пользователей, а также рассказывают об
							особенностях. Рекомендуется добавление отдельной рубрики с товарами их преимуществами или способами
							применения.
						</Typography>
					</div>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2'>Пример постов в сетке</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/2-11.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<ShareSection />
			</article>

			{similarCases.length > 0 && (
				<section className={`${styles.similar__projects}`}>
					<Typography variant='h2'>Похожие проекты</Typography>
					<div className={`${styles.cases__cards}`}>
						{similarCases.slice(0).map(({ img, href, badge, description, title }, idx) => (
							<div className={styles.case} key={idx}>
								<div className={styles.card}>
									<NextImage
										className={styles['card-image']}
										src={img}
										alt=''
										fill
										priority
										sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
									/>
									<div className={styles.badge}>{badge}</div>
									<div className={styles['card-hover']}>
										<div className={styles['card-hover__content']}>
											<span className={styles['card-hover__text-small']}>Ознакомиться с кейсом</span>
											{/* <span className={styles["card-hover__text-big"]}>x3</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Рост конверсии
                      </span>
                      <span className={styles["card-hover__text-big"]}>60</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Часов работы
                      </span> */}
											<IconButton
												Icon={UpRightArrowIcon}
												variant='circle'
												className={styles['card-hover__button']}
											/>
										</div>
									</div>
								</div>
								<Typography variant='h5' className={styles.case__headline}>
									{title}
								</Typography>
								<Typography variant='p2' color='description' className={styles.case__description}>
									{description}
								</Typography>
							</div>
						))}
					</div>
				</section>
			)}
		</>
	)
}
